export default {
    //新版本请求成功返回
    RES_CODE: {
        SUCCESS: '0',
        ERROR_1: '400201',  //token不能为空
        ERROR_2: '400202',  //非法token
        ERROR_3: '400203',  //失效token token过期
        ERROR_4: '400204',  //用户不存在
        ERROR_5: '400205',  //密码不正确
        ERROR_6: '400206'   //非法权限
    },
    USER_MANANGER: {//用户设置
        SET: "set",
        USER_LIST : "userlist", //用户管理
        USER_DETAIL: "userdetail", //用户详情列表
        INTERNAL_PERMISSIONS: "internalpermissions", //内部权限
        COMPANY_USER_LIST: "company_user_list" //公司人员列表
    }
}